import React from 'react'
import PropTypes from 'prop-types'
import CustomLink from '../components/CustomLink'

const Award = (props) => {
    return (
        <CustomLink to={props.to} {...props}>
            <img
                src={`/images/${props.src}`}
                alt={props.alt ? props.alt : ''}
                height={props.height ? props.height : 140}
                style={{ marginTop: props.height ? `${140 - props.height}px` : '' }}
                loading='lazy'
            />
        </CustomLink>
    )
}

Award.propTypes = {
    to: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
}

export default Award



// WEBPACK FOOTER //
// ./resources/js/elements/Award.js